import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, Card } from '@clari/ui'

const SUPPORT_MAILTO = 'mailto:support@withclari.com'

export type KycResultStatus = 'pending' | 'approved' | 'rejected' | 'more_info'

export function KycResult({ status }: { status: KycResultStatus }) {
  const { t } = useTranslation('auth')
  const navigate = useNavigate()

  const content = {
    pending: { title: t('kyc.pending_title'), body: t('kyc.pending_body') },
    approved: { title: t('kyc.approved_title'), body: t('kyc.approved_body') },
    rejected: { title: t('kyc.rejected_title'), body: t('kyc.rejected_body') },
    more_info: { title: t('kyc.more_info_title'), body: t('kyc.more_info_body') },
  }[status]

  return (
    <div className="mx-auto max-w-xl">
      <Card>
        <h1 className="text-2xl font-semibold">{content.title}</h1>
        <p className="mt-2 text-text-muted">{content.body}</p>
        <div className="mt-6">
          {status === 'approved' ? (
            <Button onClick={() => navigate('/app', { replace: true })} withSignatureDot>
              {t('kyc.approved_cta')}
            </Button>
          ) : null}
          {status === 'more_info' ? (
            <Button onClick={() => navigate('/app/onboarding/kyc', { replace: true })}>
              {t('kyc.more_info_cta')}
            </Button>
          ) : null}
          {status === 'rejected' ? (
            <a
              href={SUPPORT_MAILTO}
              className="inline-block rounded-md border border-border px-4 py-2 text-sm font-medium text-text"
            >
              {t('kyc.rejected_cta')}
            </a>
          ) : null}
        </div>
      </Card>
    </div>
  )
}
